
export default class Encrypt {
    static SIGN_KEY = "L9gh=p%Eozfn2#@";

    //产品会话密钥
    static DATA_KEY: string = '48ef8b4810e9260625c';

    /**
     * 获取秘密密钥
     */
    static get getSecretKey(): string {
        return this.DATA_KEY;
    }

}
